import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const base = 'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-500 ' +
    'disabled:opacity-50 disabled:cursor-not-allowed select-none';
const variants = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 shadow-sm',
    secondary: 'bg-white text-slate-900 hover:bg-slate-50 ring-1 ring-slate-200 shadow-sm',
    ghost: 'bg-transparent text-slate-700 hover:bg-slate-100',
    danger: 'bg-red-600 text-white hover:bg-red-700 active:bg-red-800 shadow-sm',
};
const sizes = {
    sm: 'text-sm h-8 px-3',
    md: 'text-sm h-10 px-4',
    lg: 'text-base h-12 px-6',
};
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', className = '', ...rest }, ref) {
    return (_jsx("button", { ref: ref, ...rest, className: `${base} ${variants[variant]} ${sizes[size]} ${className}` }));
});
